module.exports = __webpack_public_path__ + "static/media/footimg.78f7bce3.png";